<template>
    <div>
        <el-table
            :data="tableData"
            border
            size="small"
            style="width: 100%">
            <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
            <el-table-column prop="driverName" label="姓名" align="center" width="100"></el-table-column>
            <el-table-column prop="driverPhone" label="手机号" align="center" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.driverPhone">{{scope.row.driverPhone.substring(0,3)+'****'+scope.row.driverPhone.substring(7,scope.row.driverPhone.length)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="msgType" label="类型" align="center" width="60">
                <template slot-scope="scope">
                    <span v-if="scope.row.msgType == 1">咨询</span>
                    <span v-else-if="scope.row.msgType == 2">投诉</span>
                    <span v-else>反馈</span>
                </template>
            </el-table-column>
            <el-table-column prop="checkStatus" label="状态" align="center" width="80">
                <template slot-scope="scope">
                    <span v-if="scope.row.checkStatus == 1"><el-tag>已查阅</el-tag></span>
                    <span v-else-if="scope.row.checkStatus == 2"><el-tag type="success">已回复</el-tag></span>
                    <span v-else><el-tag type="warning">未查阅</el-tag></span>
                </template>
            </el-table-column>
            <el-table-column prop="msg" label="意见内容" align="center" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="replyContent" label="回复内容" align="center" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="发起时间" align="center" width="100" :formatter="formatter"></el-table-column>
            <el-table-column prop="updateTime" label="处理时间" align="center" width="100" :formatter="formatter"></el-table-column>
            <el-table-column prop="satisfaction" label="满意度" align="center" width="70">
                <template slot-scope="scope">
                    <span v-if="scope.row.satisfaction == 0"><el-tag type="danger">不满意</el-tag></span>
                    <span v-else-if="scope.row.satisfaction == 1"><el-tag type="success">满意</el-tag></span>
                    <span v-else>-</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            style="text-align: right; height: 50px;margin-top: 10px;"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="categoryList.currentPage"
            :page-sizes="pageSizes"
            :page-size="categoryList.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalPage">
        </el-pagination>
    </div>
</template>

<script>
import { getFeedbackList } from '@/api/api'

export default {
    name: 'feedbackListModal',
    data () {
        return {
            loading: true,
            defaultActive: null,
            categoryList: [],
            newsList: [],
            currentPage: 1,
            pageSize: 10,
            totalPage: 1,
            pageSizes: [10, 20, 30],
            menuActiveKey: null,
            tableData: []
        }
    },
    created () {
        this.loadData()
    },
    methods: {
        handleSizeChange (val) {
            this.pageSize = val
            this.loadData()
        },
        handleCurrentChange (val) {
            this.currentPage = val
            this.loadData()
        },
        loadData () {
            this.loading = true
            let params = {
                pageNo: this.currentPage,
                pageSize: this.pageSize
            }
            getFeedbackList(params).then(res => {
                if (res.data.success) {
                    let result = res.data.result
                    this.tableData = result.records
                    this.currentPage = result.current
                    this.pageSize = result.size
                    this.totalPage = result.total
                }
            })
        },
        formatter (row, column) {
            return row[column.property].substring(0, 10)
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/consult/modules/feedbackListModal.vue